export var ClientScripts;
(function (ClientScripts) {
    ClientScripts[ClientScripts["BetGames"] = 1] = "BetGames";
    ClientScripts[ClientScripts["BetRadar"] = 2] = "BetRadar";
    ClientScripts[ClientScripts["GlobalBet"] = 3] = "GlobalBet";
    ClientScripts[ClientScripts["GoldenRace"] = 4] = "GoldenRace";
    ClientScripts[ClientScripts["IncentiveGames"] = 5] = "IncentiveGames";
    ClientScripts[ClientScripts["Kiron"] = 6] = "Kiron";
    ClientScripts[ClientScripts["nsoft"] = 7] = "nsoft";
    ClientScripts[ClientScripts["ScoutGaming"] = 8] = "ScoutGaming";
    ClientScripts[ClientScripts["Authentic"] = 9] = "Authentic";
    ClientScripts[ClientScripts["Leap"] = 10] = "Leap";
    ClientScripts[ClientScripts["Bitville"] = 11] = "Bitville";
    ClientScripts[ClientScripts["TwainSports"] = 12] = "TwainSports";
    ClientScripts[ClientScripts["BetGamesNew"] = 13] = "BetGamesNew";
    ClientScripts[ClientScripts["Pragmatic"] = 14] = "Pragmatic";
    ClientScripts[ClientScripts["OnAirEntertainment"] = 15] = "OnAirEntertainment";
})(ClientScripts || (ClientScripts = {}));
export const clientScriptSelector = new Map([
    [ClientScripts.BetGames, "BetGames"],
    [ClientScripts.BetRadar, "BetRadar"],
    [ClientScripts.GlobalBet, "GlobalBet"],
    [ClientScripts.GoldenRace, "GoldenRace"],
    [ClientScripts.IncentiveGames, "IncentiveGames"],
    [ClientScripts.Kiron, "Kiron"],
    [ClientScripts.nsoft, "nsoft"],
    [ClientScripts.ScoutGaming, "ScoutGaming"],
    [ClientScripts.Authentic, "Authentic"],
    [ClientScripts.Leap, "Leap"],
    [ClientScripts.Bitville, "Bitville"],
    [ClientScripts.TwainSports, "TwainSports"],
    [ClientScripts.BetGamesNew, "BetGamesNew"],
    [ClientScripts.Pragmatic, "Pragmatic"],
    [ClientScripts.OnAirEntertainment, "OnAirEntertainment"],
]);
